/* global ContainerExt, initPanzoom, IRTConfig, AmazonCognitoIdentity, $ */
/*
  This file stores common objects for different modules and common files/methods
  shared between windows.
*/

// external packages
import Prism from 'prismjs';
//import urlJoin from 'url-join';
import XLSX from 'xlsx/xlsx.mini';
import nunjucks from 'nunjucks';
let env = nunjucks.configure('views', {
  autoescape: false // do not add escape symbols to input string
});

// irt nav structure
import centralStructure from './structure';
// exported formats
import defaultExport from './default-export';
// irt-nav info
import { version as navVersion, homepage as navHomepage } from '../../package.json';
// heta-compiler info
import { version as hetaVersion, homepage as hetaHomepage } from 'heta-compiler/package';

// = top level variables = 
// use class from file "./heta-ext/index.js"
let container = null;
// loaded in runApp()
let svgStyle = null;
// loaded in initCentralModal()
let versionList = null;

// = global (window) variables =
global.openSvgScheme = openSvgScheme;
// global.openSection = openSection;

// authentication
const { CognitoAuth } = AmazonCognitoIdentity;
// fake CognitoAuth instance
function FakeCognitoAuth(){ // fake CognitoAuth instance
  this.getSession = () => {
    let result = {
      accessToken: {}
    };
    this.userhandler.onSuccess(result);
  };
  this.signOut = () => {
    //do nothing
  };
  this.useCodeGrantFlow = () => {
    //do nothing
  };
  this.getCachedSession = () => {
    return {
      accessToken: { jwtToken: 'nothing'}
    };
  };
  this.signInUserSession = {
    idToken: {
      payload: {
        email: 'pupkin@xxxxx.xxx',
        given_name: 'Vasily',
        family_name: 'Pupkin',
        phone_number: '+0(000)000-0000'
      }
    }
  };
}
const auth = global.auth = !IRTConfig.offlineMode
  ? new CognitoAuth(IRTConfig.cognito) // set authentication
  : new FakeCognitoAuth();
auth.useCodeGrantFlow();
// promisify auth.getSession()
function getSessionPromise(){
  return new Promise((resolve, reject) => {
    auth.userhandler = { onSuccess: resolve, onFailure: reject };
    auth.getSession();
  });
}

// = window events =
$(window).on('load', runApp);
// $(window).on('unload', closeAnnotationWindow);
$(window).on('resize', updateWindowHeight);

// main app loading flow
async function runApp(){
  // save svg specific style as variable
  svgStyle = $('#style-svg g')[0];
  // main content and navigation events
  loadBase();
  // initial section
  openSection('pages');
  // load list(.json) and get default version id
  let localStorageVersion = await initCentralModal(); 
  
  selectVersion(localStorageVersion); // async
  // => loadContent()
}

// removes old content and load the whole db
async function loadContent(versionId = ''){
  // reset panels
  $('#pagesUl').html('');
  $('#schemesUl').html('');
  $('#infoDiv').html('Information:');
  $('#debugDiv').html('');
  $('.codePanel').html('');
  // create container
  let dbPath = IRTConfig.versionAsPath
    ? `${IRTConfig.dbPath}${versionId}/`
    : `${IRTConfig.dbPath}/`;
  container = new ContainerExt(dbPath, versionId);

  // set log transport
  container.setDebugDisplay($('#debugDiv').get(0));

  // load indexes.xml
  let indexesDoc = await ajax(versionId, 'indexes.xml', { dataType: 'xml' });

  // load iddb.xml and load to container
  let iddbFilepath = $(indexesDoc).find('identifications').attr('path');
  let branch1 = ajax(versionId, iddbFilepath, { dataType: 'text' })
    .then((iddbCode) => container.loadIddb(iddbCode)); // #1
  initViewer(indexesDoc);
  
  let schemes = initializeSchemesNav(versionId, indexesDoc);
  let pages = initializePagesNav(versionId, indexesDoc);
  
  let branch2 = loadModel(versionId, indexesDoc)
    .then(() => openSvgScheme(schemes[0].id, versionId, indexesDoc)); // #2
  let branch3 = openHtmlPage(pages[0].id, versionId, indexesDoc); // #3

  // XXX: not sure this works as expected
  // run all in parallel
  await Promise.all([branch1, branch2, branch3]); 

  // if everything is loaded
  $('#welcomeModal').hide();
}

function loadBase() {
  // update irt-nav info
  centralStructure.footer.content1.html 
    = `<a href="${navHomepage}" target="_blank">IRT Navigator <strong>${navVersion}</strong></a>`;
  // update heta info
  centralStructure.footer.content2.html 
    = `Powered by <a href="${hetaHomepage}" target="_blank">Heta compiler ${hetaVersion}</a>`;
  // add central part to app
  let HTMLCode = env.render('central.njk.html', {
    base: centralStructure,
    export: defaultExport
  });
  $('#centralDiv').html(HTMLCode);

  // section selection
  $('#openPages').on('click', () => openSection('pages'));
  $('#openSchemes').on('click', () => openSection('schemes'));
  $('#openTable').on('click', () => openSection('table'));
  $('#openExport').on('click', () => openSection('export'));

  /*
  // filter
  document.getElementById('filter').addEventListener('change', () => {
    filterSbml();
  });
  */

  // right div
  $('#hideRightDiv').on('click', () => {
    $('#rightDiv, #resizer').toggle();

    let isOpen = $('#rightDiv').is(':visible');
    if (isOpen) {
      $('#hideRightDiv i.fa')
        .addClass('fa-angle-double-right')
        .removeClass('fa-angle-double-left');
    } else {
      $('#hideRightDiv i.fa')
        .addClass('fa-angle-double-left')
        .removeClass('fa-angle-double-right');
    }
  });
  // markers in right div, click default marker is first
  centralStructure.main.markers.forEach((marker) => {
    $(`#${marker.id}`).on('click', { id: marker.id, link: marker.link }, clickMarker);
  });
  // hide debug panel
  if (!IRTConfig.debugMode)
    $('#debugDivLink').hide();
  
  // mass selection
  $('#selectAllSheme').on('click', () => container.includeVisible());
  $('#deselectAllSheme').on('click', () => container.excludeVisible());
  $('#selectAllTable').on('click', () => container.includeAll());
  $('#deselectAllTable').on('click', () => container.excludeAll());

  // save and export
  $('#saveIncluded').on('click', {}, saveIncluded);
  $('#loadIncluded').on('click', {}, () => $('#loadIncludedFile').trigger('click')); // virtual click of input
  $('#loadIncludedFile').on('change', {}, loadIncluded);

  // export to different formats
  defaultExport.forEach((item) => {
    $(`#${item.id}Panel .showButton`).on('click', item , showCode);
    $(`#${item.id}Panel .removeButton`).on('click', item, removeCode);
    $(`#${item.id}Panel .downloadButton`).on('click', item, downloadCode);
  });

  // initialize panzoom
  // take function from file "zoom.js"
  initPanzoom();
    
  // manual on/off welcome modal
  $('#profile').on('click', () => $('#welcomeModal').show());
  $('#closeWelcomeModal').on('click', () => $('#welcomeModal').hide());

  // first resize
  updateWindowHeight();

  // init resizer
  $('#resizer').on('mousedown', startRightDivResize);
}

function startRightDivResize(evt){
  let initialX = evt.clientX;
  let initialWidth = $('#rightDiv').outerWidth();

  $(window).on('mousemove', { initialX, initialWidth }, rightDivResize);
  $(window).on('mouseup', stopRightDivResize);
}

function rightDivResize(evt){
  let move = evt.clientX - evt.data.initialX;
  let width = evt.data.initialWidth - move;

  $('#rightDiv').outerWidth(width);
}

function stopRightDivResize(){
  $(window).unbind('mousemove');
  $(window).unbind('mouseup');
  // update mathjax in infoDiv
  MathJax.Hub.Queue(['Rerender', MathJax.Hub]);
}

// open one of marken in right panel
function clickMarker(evt){
  let { link, id } = evt.data;
  $('#markersDiv > div')
    .removeClass('w3-grey')
    .addClass('w3-light-blue')
    .css('box-shadow', 'none');
  $(`#${id}`)
    .removeClass('w3-light-blue')
    .addClass('w3-grey')
    .css('box-shadow', '6px 6px 3px #bbb');

  // open link
  $('#rightDiv > div').hide();
  $(`#${link}`).show();

  // open rightDiv if not opened
  let isOpen = $('#rightDiv').is(':visible');
  if (!isOpen) {
    $('#rightDiv, #resizer').show();
    $('#hideRightDiv i.fa')
      .addClass('fa-angle-double-right')
      .removeClass('fa-angle-double-left');
  }
}

// SAVE / LOAD
function saveIncluded(){
  let includedIds = container.defaultNS
    .selectByInstanceOf('Record')
    .filter((component) => component.isIncluded())
    .map((component) => component.id);
  let databaseVersion = versionList.find((x) => x.selected);
  let output = {
    source: 'IRT navigator',
    version: navVersion,
    databaseVersion: databaseVersion,
    included: includedIds
  };
  let json = JSON.stringify(output, null, 2);

  //create invisible link
  let bb = new Blob([json], { type: 'text/plain' });
  let url = window.URL.createObjectURL(bb);

  let pom = $('<a download="irt-save.json" draggable="true" class="dragout"/>')
    .attr('href', url);

  pom[0].click();
}
function loadIncluded(evt){
  evt.preventDefault(); // prevent refreshing of whole page

  // read selected file
  let file = evt.target.files[0];
  let fr = new FileReader();

  // waiting reader
  fr.onload = function(){
    let json = this.result.toString(); // content of text file
    let parsed = JSON.parse(json);

    // check file
    if (parsed.source !== 'IRT navigator')
      throw new Error(`Wrong format of file "${file.name}"`);

    // exclude all components
    container.excludeAll();

    // search and update selection
    container.includeById(parsed.included);

    // final alert
    alert(parsed.included.length + ' components are included now.');
  };

  fr.readAsText(file);

  console.log('Loading included...');
}

function showCode(evt){
  let { id, q, options } = evt.data;

  // spinner on
  $(evt.target).find('i.fa').show();

  setImmediate(() => { // this required to make it async
    // clear ns and copy components
    container.populateByIncluded();

    // generate code
    let exportObj = container.export(q);
    let generated = exportObj.make()[options.toShow];

    let codePanel = $(`#${id}Panel .codePanel`)
      .text(generated.content);

    // run Prism Highliter
    Prism.highlightElement(codePanel[0]);
    // spinner off
    $(evt.target).find('i.fa').hide();
    
  });
}

function removeCode(evt){
  let { id } = evt.data;

  $(`#${id}Panel .codePanel`).text('');
}
 
function downloadCode(evt){
  let { q, options } = evt.data;

  // spinner on
  $(evt.target).find('i.fa').show();
  
  setImmediate(() => { // this required to make it async
    // clear ns and copy components
    container.populateByIncluded();
    // generate code
    let exportObj = container.export(q);
    let generated = exportObj.make();

    if (options.type ==='text/plain' || typeof options.type === 'undefined') {
      //create invisible link
      let bb = new Blob([generated[options.toShow].content], { type: options.type || 'text/plain' });
      let url = window.URL.createObjectURL(bb);

      let pom = $(`<a download="${exportObj.filepath + generated[options.toShow].pathSuffix}" draggable="true" class="dragout"/>`)
        .attr('href', url);

      // this is additional code from previous irt, it seems not required
      //pom[0].dataset.downloadurl = ['text/plain', pom[0].download, pom[0].href].join(':');

      // pom.trigger('click'); // not working
      pom[0].click();
    } else if (options.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      console.log('Run downloading XLSX file...');
      let wb = XLSX.utils.book_new();
      generated.forEach((x) => {
        let omitRows = x.omitRows !== undefined
          ? x.omitRows
          : exportObj.omitRows;
        let ws = XLSX.utils.json_to_sheet(
          Array(omitRows).fill({}).concat(x.content),
          { header: x.headerSeq, skipHeader: x.skipHeader }
        );
        XLSX.utils.book_append_sheet(wb, ws, x.name);
      });
      XLSX.writeFile(wb, exportObj.filepath + '.xlsx', {});
    } else {
      throw new Error(`Unknown mime type: "${options.type}"`);
    }

    // spinner off
    $(evt.target).find('i.fa').hide();
  });
}

async function initCentralModal(){
  // personal info
  let idPayload = auth.signInUserSession.idToken.payload;

  if (!IRTConfig.offlineMode) { // online mode
    // try to load versions list
    versionList = await ajax('', 'list', { dataType: 'json' });
    
    // load content
    let HTMLCode = env.render('_welcomeModalContent.html', { idPayload, versionList });
    $('#welcomeModalContent').html(HTMLCode);
    // set modal events
    $('#versionList .irt-version')
      .each((i, node) => $(node).on('click', () => selectVersion(node.id)));
    $('#endIrtSession').on('click', () => auth.signOut());

    // use id from local storage if exist
    var localStorageVersion = localStorage.getItem('irtDBVersion');
    if (IRTConfig.debugMode)
      console.log(`The value of "irtDBVersion" in localStorage was: "${localStorageVersion}"`);

  } else { // offline mode
    versionList = [{ // local version
      id: 'offline',
      title: 'Local version',
      notes: 'You cannot change version in offline mode. Use "dbPath" property in file "nav.config.js"'
    }];

    let HTMLCode = env.render('_welcomeModalContent.html', { idPayload, versionList });
    $('#welcomeModalContent').html(HTMLCode);

    // use id from first element
    localStorageVersion = versionList[0].id;
  }

  return localStorageVersion;
}

/*
  change version of irtdb
*/
async function selectVersion(versionIdNew) {
  // reset errors
  $('#errorPanel').html('');

  // find previous version
  let previousVersion = versionList.find((x) => x.selected);
  let version = versionList.find((x) => x.id === versionIdNew);

  // if previous is not the same as current
  if (!previousVersion || previousVersion.id !== versionIdNew) {
    if (previousVersion) {
      // get id for searching by jquery
      let safePreviousId = previousVersion.id.replace(/[.]/g, '\\.');
      // reset previous version
      $(`#versionList #${safePreviousId}.irt-version`)
        .removeClass('irt-version-selected')
        .removeClass('w3-border')
        .removeClass('w3-border-green');
      previousVersion.selected = false;
    }
    // set current version, skip for empty id
    if (version && version.id) { // else $('#welcomeModal').show();
      // get id for searching by jquery
      let safeId = version.id.replace(/[.]/g, '\\.');
      $(`#versionList #${safeId}.irt-version`)
        .addClass('irt-version-selected')
        .addClass('w3-border')
        .addClass('w3-border-green');
      $(`#versionList #${safeId}.irt-version i.fa`).show();

      try {
        await loadContent(version.id); // versionId async
        // save selected
        version.selected = true;
        localStorage.setItem('irtDBVersion', version.id);
        if (IRTConfig.debugMode)
          console.log(`The value of "irtDBVersion" in localStorage was set as: "${version.id}"`);
      } catch (error) {
        let msg = `<p>Cannot load content for "${versionIdNew}".</p> <p>Status: ${error.statusText} ${error.status}</p>`;
        $('#errorPanel').html(msg);
        throw error;
      } finally {
        $(`#versionList #${safeId}.irt-version i.fa`).hide();
      }
    }
  }
}

async function loadModel(versionId = '', indexesDoc){
  let filepath = $(indexesDoc).find('model').attr('path');
  let smblCode = await ajax(versionId, filepath, { dataType: 'text' });
  container.loadSBML(smblCode);

  container.makeTable($('#table-content'));
  container.makeIncludedPanel($('#includedDiv'));
  container.setInfoPanel($('#infoDiv')[0]);
  let schemesSummary = $(indexesDoc).find('schemes').get(0);
  container.setSchemesSummary(schemesSummary);
}

// initialize everything except model parts
function initViewer(indexesDoc) {
  // = initialize table =
  $('#compartmentsTableLink')
    .on('click', { target: '#compartmentsTable', content: '#table-content' }, scrollTo);
  $('#speciesTableLink')
    .on('click', { target: '#speciesTable', content: '#table-content' }, scrollTo);
  $('#reactionsTableLink')
    .on('click', { target: '#reactionsTable', content: '#table-content' }, scrollTo);

  // = initialize export =
  // scroll-method
  /*
  defaultExport.forEach((item) => {
    $(`#${item.id}Link`)
      .on('click', { target: `#${item.id}Container`, content: '#export-content'}, scrollTo);
  });
  */
  // hide-method
  defaultExport.forEach((item) => {
    $(`#${item.id}Link`)
      .on('click', { target: `#${item.id}Container`, content: '#export-content' }, showContent);
  });
  // show first export
  let zeroId = defaultExport[0].id;
  showContent({data: { target: `#${zeroId}Container`, content: '#export-content' }});

  // = create footer =
  let root = indexesDoc.documentElement;
  let name = $(root).attr('name');
  let version = $(root).attr('version');
  let copyright = $(root).attr('copyright');

  $('#footerContent3').html(`${name} ${version} by ${copyright}`);

  // disable filter.css
  //document.styleSheets[getNumberFilterStyleshet()].disabled = true;
}

function scrollTo(evt){
  let { target, content } = evt.data;
  let x = $(target).offset().top;
  let y = $(`${content} div`).offset().top;

  $(content).animate({ scrollTop: x-y }, 'slow');
}

function showContent(evt){
  let { target, content } = evt.data;
  $(`${content} div`).hide();
  $(target).show();
}

// open section
function openSection(section){ // id of <div> element to open
  // set style for other
  $('.section').css('display', 'none');
  $('.sectionLink').removeClass('w3-grey');

  // set style for target
  let backRef = $('#' + section)
    .css('display', 'block')
    .attr('backRef');
    
  if (backRef)
    $('#' + backRef).addClass('w3-grey');
}

// initialize pages navigation: left panel
function initializePagesNav(versionId = '', indexesDoc) {
  let pages = $(indexesDoc).find('page');
  pages.each((i, node) => {
    let pageElement = $(node)
      .attr('num', i);

    // create nav
    let description = pageElement.find('description').text();
    $('<li class="leftLink1"/>')
      .appendTo('#pagesUl')
      .text(pageElement.attr('name'))
      .on('click', {}, () => openHtmlPage(node.id, versionId, indexesDoc))
      .attr('title', description);
  });

  return pages;
}

// initialize schemes navigation: left panel
function initializeSchemesNav(versionId = '', indexesDoc) {
  // search pages and create left navigation
  let schemes = $(indexesDoc).find('scheme[active="true"]');
  schemes.each((i, node) => {
    let schemeElement = $(node)
      .attr('num', i);

    // create nav
    let description = schemeElement.find('description').text();
    $('<li class="leftLink2"/>')
      .appendTo('#schemesUl')
      .text(schemeElement.attr('name'))
      .on('click', {}, () => openSvgScheme(node.id, versionId, indexesDoc))
      .attr('title', description);
  });

  return schemes;
}

// change scheme in central part
async function openSvgScheme(id, versionId = '', indexesDoc) {
  // change view of left panel
  let num = $(indexesDoc).find('#' + id).attr('num');
  // change navigation style
  $('.leftLink2')
    .removeClass('w3-grey')
    .eq(num).addClass('w3-grey');

  let scheme = await ajax(versionId, `schemes/${id}.svg`, { dataType: 'xml' });

  // SVG with scheme
  let schemeNode = scheme.firstChild;
  // add patterns for advanced styling
  schemeNode.appendChild(svgStyle); // append style to main svg

  // set panzoom
  $('#panzoom')
    .empty()
    .append(scheme.firstChild);

  container.loadScheme(schemeNode);

  return scheme;
}

// automatic window height
function updateWindowHeight() {
  let h = document.documentElement.clientHeight -
    $('#topDiv').outerHeight() -
    $('#footerDiv').outerHeight();

  $('.forceHeight').height(h + 'px');
}

/*
function filterSbml(){
  var res;
  var line = document.getElementById('filter').value.toLowerCase();
  if(line!==''){
    // default values for covered
    var searchLine = '//sbml:*[@covered=\'false\']';
    res = window.modelDoc.evaluate(
      searchLine,
      window.modelDoc,
      irtns,
      XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
      null
    );
    for (let i = 0; i<res.snapshotLength; i++) {
      res.snapshotItem(i).setAttribute('covered', 'true');
    }

    // if search successful then covered=false
    let bigLet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let smallLet = 'abcdefghijklmnopqrstuvwxyz';
    var searchLine = `//sbml:*[@name[contains(translate(.,'${bigLet}','${smallLet}'),'`
      + `${line}')] or @id[contains(translate(.,'${bigLet}','${smallLet}'),'`
      + `${line}')]or sbml:notes/text()[contains(translate(.,'${bigLet}','${smallLet}'),'`
      + `${line}')] or @speciesType=//sbml:speciesType[sbml:notes/text()[contains(translate(.,'${bigLet}','${smallLet}'),'`
      + `${line}')]]/@id]`;
    res = window.modelDoc.evaluate(
      searchLine,
      window.modelDoc,
      irtns,
      XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
      null
    );
    for (let i = 0; i<res.snapshotLength; i++) {
      res.snapshotItem(i).setAttribute('covered', 'false');
    }
    document.styleSheets[getNumberFilterStyleshet()].disabled = false;
  }else{
    document.styleSheets[getNumberFilterStyleshet()].disabled = true;
  }
}
*/

/*
// XXX: I do not understand this part at all.
function getNumberFilterStyleshet() { 
  let i = null;
  do {
    i++;
  } while (document.styleSheets[i].title !== 'filter');
  return i;
}
*/
async function openHtmlPage(id, versionId = '', indexesDoc) {
  // change view of left panel
  let num = $(indexesDoc).find('#' + id).attr('num');
  // change navigation style
  $('.leftLink1')
    .removeClass('w3-grey')
    .eq(num).addClass('w3-grey');

  // open page
  let filepath = $(indexesDoc).find('#' + id).attr('path');
  let res = await ajax(versionId, filepath, { dataType: 'xml' });

  $('#pages-content')
    .empty()
    .append(res.documentElement);

  // update equations
  MathJax.Hub.Queue(['Typeset', MathJax.Hub]);

  return res;
}

/*
  the same as $.ajax but include authorization and sent errors to window
*/
let counter = 0; // counter of get session calls
async function ajax(version, path, settings){
  // XXX: I guess the getSession() should be used ones but previously 
  // there were some problems with that
  // check authorization
  try {
    var result = await getSessionPromise();
  } catch (error) {
    let msg = '<p>Authorization problems</p>';
    $('#errorPanel').html(msg);
    $('#welcomeModal').show();
    // XXX: sign out in case of some problems
    auth.signOut();
    //throw error;
  }
  if (IRTConfig.debugMode) 
    console.log('getSession OK: ', ++counter);

  // preparations
  let jwtToken = result.accessToken.jwtToken;
  let fullUrl = IRTConfig.versionAsPath
    ? `${IRTConfig.dbPath}/${version}/${path}?token=${jwtToken}`
    : `${IRTConfig.dbPath}/${path}?&version=${version}&token=${jwtToken}`;

  // download file
  let dataPromise = $.ajax(fullUrl, settings).promise();
  try {
    return await dataPromise;
  } catch (error) {
    let msg = `<p>Cannot GET file.</p> <p>"${path}" Status: ${error.statusText} ${error.status}</p>`;
    $('#errorPanel').html(msg);
    $('#welcomeModal').show();
    throw error;
  }
}
